import { EXERCISE_LOG_SUMMARY_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getOneRepMaxExerciseLogSummaryUtil (instance) {
  return getValueReduxUtil(instance, EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX)
}

export default getOneRepMaxExerciseLogSummaryUtil
